import Qty from 'js-quantities';

type RawValue = string | number | null;

export const unitsOptions = [
  { value: 'imperial', label: 'Imperial' },
  { value: 'metric', label: 'Metric' },
] as const;

export const weightUnits = {
  imperial: 'lbs',
  metric: 'kg',
} as const;

export const heightUnits = {
  imperial: 'in',
  metric: 'cm',
} as const;

export const feetInchesToInches = (maskString: string) => {
  const [foots, inches] = maskString.split('\'');
  if (!inches) return '0';
  let totalInches;
  switch (inches) {
    case '1_"': {
      totalInches = 1;
      break;
    }
    case '_"': {
      totalInches = 0;
      break;
    }
    default: totalInches = +inches.slice(0, -1);
  }
  return `${+foots * 12 + totalInches}`;
};

export const inchesToFeetInches = (inches: number) => `${Math.floor(inches / 12)}'${Math.floor(inches % 12)}"`;

export const weightConvert = (rawValue: RawValue, from: string, to: string) => {
  if (!rawValue || !from || !to || from === to) {
    return rawValue;
  }

  return Qty.swiftConverter(
    weightUnits[from],
    weightUnits[to],
  )(rawValue);
};

export const heightConvert = (rawValue: RawValue, from: string, to: string) => {
  if (!rawValue || !from || !to || from === to) {
    return rawValue;
  }

  return Qty.swiftConverter(
    heightUnits[from],
    heightUnits[to],
  )(rawValue);
};
